<template>
  <div class="modes">
     <ul>
       <li v-for="(mode, index) in modes" :key="index" :class="{active: mode.active}" @click="switchModes(mode.name)">{{ mode.name }} </li>
     </ul>
  </div>
</template>

<script>
import EventBus from '../../../EventBus'
  export default {
    data(){
      return {
        modes: [
          {name: 'Normal Mode', active: true},
          {name: 'List Mode', active: false},
        ]
      }
    },
    mounted(){
      EventBus.$on('exited-list', () => {
          this.modes[1].active = false;
          this.modes[0].active = true; 
          EventBus.$emit('record-mode-changed', "Normal Mode")
      })
    },
    methods: {
      switchModes(name){
         this.modes.forEach(mode => {
            mode.active = false;

            if(mode.name == name){
               mode.active  = true;
               EventBus.$emit('record-mode-changed', name)
            }
         })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modes{
    display: inline-block;

    ul{
      list-style-type: none;
      li{
        display: inline-block;
        font-size: 13px;
        padding: 5px 10px;
        background-color: rgb(225, 228, 236);
        color: rgb(104, 109, 121);
        cursor: pointer;
        margin-right: 5px;
        border-radius: 5px;
        text-transform: uppercase;
      }
      li.active{
        background-color: #ff6b15;
        color: #fff;
      }
    }
  }
</style>